module.exports = __webpack_public_path__ + "img/zamkniecia-drog.ed76fa34.svg";